<template>
  <div
    class="leadership-lider-block"
    :class="{ 'leadership-lider-block--right': rightPosition }"
    v-if="data"
  >
    <div class="container">
      <div class="row">
        <div
          class="col-l-4 col-m-4 col-s-12 lider__image"
          v-if="data.image.url"
          :style="{ 'background-image': 'url( '+ data.image.url +' )' }"
        ></div>
        <div class="col-l-8 col-m-8 col-s-12 lider__content">
          <h2>
            <div class="lider__title" v-if="data.title">{{ data.title }}</div>
            <div class="lider__subtitle" v-if="data.subtitle">{{ data.subtitle }}</div>
          </h2>
          <div class="lider__description" v-if="data.description" v-html="data.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leadership-lider-block",
  props: {
    data: Object,
    rightPosition: Boolean,
  }
};
</script>


// WEBPACK FOOTER //
// LeadershipLiderBlock.vue?005457b5